<template>
  <article class="strategy-card">
    <div class="strategy-card__head">
      <div>
        <h3>{{ strategy.name }}</h3>
        <div class="strategy-card__tag" :style="{ color: strategy.tagColor }">
          {{ strategy.tag }}
        </div>
      </div>
      <span class="strategy-card__risk" :class="strategy.riskClass">
        {{ strategy.risk }}风险
      </span>
    </div>
    <p>{{ strategy.description }}</p>
    <div class="strategy-card__chart">
      <EChartLine
        v-if="strategy.points && strategy.points.length"
        :points="strategy.points"
        :aria-label="`${strategy.name} 近 30 日收益趋势`"
      />
      <span v-else class="strategy-card__chart-empty">登录后查看收益曲线</span>
    </div>
    <div class="strategy-card__performance">
      <div>
        <small>近 30 日收益率</small>
        <strong>{{ strategy.return30 }}</strong>
      </div>
      <div>
        <small>最大回撤</small>
        <b>{{ strategy.drawdown }}</b>
      </div>
    </div>
    <div class="strategy-card__meta">
      <span>在运行 {{ strategy.bots }} 台</span>
      <span>跟随资金 {{ strategy.aum }}</span>
    </div>
    <button class="up-secondary-button" type="button" @click="$emit('action', strategy)">
      {{ actionLabel }}
    </button>
  </article>
</template>

<script>
import EChartLine from './EChartLine.vue'

export default {
  name: 'StrategyCard',
  components: { EChartLine },
  props: {
    strategy: { type: Object, required: true },
    actionLabel: { type: String, default: '注册后启动' }
  }
}
</script>

<style scoped>
.strategy-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 10px;
  padding: 22px;
  border: 1px solid var(--up-line);
  border-radius: 14px;
  background: #fff;
  box-shadow: var(--up-shadow-sm), 0 6px 20px rgba(16, 24, 40, 0.04);
  transition: 0.18s ease;
}

.strategy-card:hover {
  transform: translateY(-3px);
  border-color: #a9c4f7;
  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.1);
}

.strategy-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.strategy-card h3 {
  margin: 0;
  font-size: 15.5px;
}

.strategy-card__tag {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.6px;
}

.strategy-card__risk {
  padding: 3px 10px;
  color: #b45309;
  border-radius: 999px;
  background: #fbf1df;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.strategy-card__risk.low {
  color: #0b7a47;
  background: #e8f6ee;
}

.strategy-card p {
  min-height: 42px;
  margin: 0;
  color: var(--up-muted);
  font-size: 12.5px;
  line-height: 1.65;
}

.strategy-card__chart {
  height: 56px;
}

.strategy-card__chart-empty {
  display: grid;
  height: 100%;
  place-items: center;
  color: #98a0af;
  border-radius: 8px;
  background: #f7f9fc;
  font-size: 11px;
}

.strategy-card__performance {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.strategy-card__performance > div:last-child {
  text-align: right;
}

.strategy-card__performance small {
  display: block;
  color: #8a90a0;
  font-size: 11.5px;
}

.strategy-card__performance strong {
  display: block;
  margin-top: 2px;
  color: var(--up-success);
  font-size: 22px;
  font-variant-numeric: tabular-nums;
}

.strategy-card__performance b {
  display: block;
  margin-top: 2px;
  color: #5a6072;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.strategy-card__meta {
  display: flex;
  justify-content: space-between;
  color: #8a90a0;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.strategy-card .up-secondary-button {
  width: 100%;
  margin-top: auto;
}
</style>
